import styled from "styled-components";

export const TermsCardStyle = styled.div`
background-color: #001b48;
padding: 2.5rem;
color: #fff;
width: 25%;
min-height: 213px;

& p{
	font-weight: 700;
	text-align: center;
	margin-top: 1.875rem;
}
`